"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExperimentLogger = void 0;
var fetch = require("isomorphic-fetch");
var bernie_logger_1 = require("bernie-logger");
var __1 = require("../..");
var util_1 = require("../../util");
var BATCH_PERIOD = 400;
/**
 * Retrieves and configures an `ExperimentLogger`.
 *
 * @param options Configuration options, e.g. the base URL for server side calls
 */
var getExperimentLogger = function (options) {
  var logger = options.logger || bernie_logger_1.NOOP_LOGGER;
  var loggedExperiments = new Set();
  var queue;
  var fetchWithTimeout = function (url, requestOptions) {
    var timeout;
    if (typeof window === 'undefined' && typeof options.timeout === 'number') {
      var controller_1 = new AbortController();
      timeout = setTimeout(function () {
        controller_1.abort();
      }, options.timeout);
      requestOptions.signal = controller_1.signal;
    }
    return fetch(url, requestOptions).finally(function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  };
  /**
   * Using the Abacus public API, log a batch of exposures.
   *
   * @param context The platform `Context`.
   * @param pageData The `PageData` store containing `pageName`.
   * @param exposure An Abacus exposure.
   */
  return function (context, pageData, exposure) {
    var _a;
    var overrides = ((_a = context === null || context === void 0 ? void 0 : context.debugContext) === null || _a === void 0 ? void 0 : _a.abacusOverrides) || [];
    if (queue === undefined) {
      queue = new util_1.UniqueBatchQueue(BATCH_PERIOD, function (e) {
        return e.name;
      }, function (exposures) {
        fetchWithTimeout("".concat(options.baseUrl || '', "/api/bucketing/v1/evaluateExperimentsAndLog"), {
          body: JSON.stringify({
            guid: context.deviceId,
            tpid: context.site.tpid,
            eapid: context.site.eapid,
            pageName: pageData.pageName,
            name: exposures.map(function (item) {
              return item.name;
            }),
            overrides: overrides.map(function (override) {
              return "".concat(override.id, "|0|").concat(override.bucket);
            }).join(':') || undefined
          }),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          method: 'POST'
        }).then(function () {
          exposures.forEach(function (e) {
            loggedExperiments.add(e.name);
          });
        }).catch(function (error) {
          if (logger) {
            logger.logEvent(__1.BERNIE_CORE_EVENTS.LOG_EXPERIMENT_ERROR, (0, bernie_logger_1.getErrorString)(error));
          }
        });
      });
    }
    if (!loggedExperiments.has(exposure.name)) {
      queue.add(exposure);
    }
    return true;
  };
};
exports.getExperimentLogger = getExperimentLogger;